import { render, staticRenderFns } from "./HelicopterManagementForm.vue?vue&type=template&id=2651f4bc&"
import script from "./HelicopterManagementForm.vue?vue&type=script&lang=js&"
export * from "./HelicopterManagementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports